import { Flex, Skeleton, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { useParams } from 'react-router-dom';
import { ReportType } from './ReportType';
import { useGetReportTypes } from 'query/reporting';
import { getReportTypeLabel } from 'services/reporting';
import ShowHideSidebarButton from 'components/layout/ShowHideSidebarButton';

export function ReportPage() {
    const { id } = useParams();
    const { data: reportTypes, isFetching, isError } = useGetReportTypes({ studyId: Number(id) });

    if (isFetching) {
        return <Skeleton height="40px" width="100%" m={4} />;
    }

    if (isError) {
        return <div>Error loading reportTypes.</div>;
    }

    return (
        <Tabs h="full" w="full" isLazy={true}>
            <TabList display={'flex'} pl={2}>
                <ShowHideSidebarButton includeMessage={false} />
                <Flex px={2} w="100%">
                    {reportTypes?.map((reportType) => (
                        <Tab flexShrink={0} key={reportType}>
                            {getReportTypeLabel(reportType)}
                        </Tab>
                    ))}
                </Flex>
            </TabList>
            <TabPanels>
                {reportTypes?.map((reportType) => (
                    <TabPanel key={reportType}>
                        <ReportType studyId={Number(id)} reportType={reportType} />
                    </TabPanel>
                ))}
            </TabPanels>
        </Tabs>
    );
}
